import { queryOptions } from '@tanstack/react-query'

import { getArticles, type GetArticlesParams } from './get-articles'

export const campaignQueries = {
  all: () => ['campaigns'],
  articles: () => [...campaignQueries.all(), 'articles'],
  articlesList: (params: GetArticlesParams) =>
    queryOptions({
      queryKey: [...campaignQueries.articles(), params],
      queryFn: () => getArticles(params),
    }),
}
